/**
 * Validates if an email address is in the correct format
 *
 * @param email - The email address to validate
 * @returns true if the email address is valid, false otherwise
 */
export function isEmailValid(email: string | undefined): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }

  // RFC 5322 compliant email regex (simplified version)
  // This regex pattern validates the basic structure of an email address
  // Requires at least one dot in the domain part (TLD is required)
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

  return emailRegex.test(email);
}

/**
 * Normalizes an email address by trimming whitespace and converting to lowercase
 *
 * @param email - The email address to normalize
 * @returns The normalized email address
 */
export function normalizeEmail(email: string | undefined): string {
  if (!email || typeof email !== 'string') {
    return '';
  }

  // Trim whitespace and convert to lowercase
  return email.trim().toLowerCase();
}
